/**
 * Returns the nearest weekday to the given date (Mon–Fri).
 * Sat → next Mon, Sun → next Mon, any weekday → unchanged.
 */
export function nearestWeekday(date) {
  const d = new Date(date);
  const dow = d.getDay();
  if (dow === 6) d.setDate(d.getDate() + 2); // Sat → Mon
  if (dow === 0) d.setDate(d.getDate() + 1); // Sun → Mon
  return d;
}

/**
 * Advances (or rewinds) the given date by `delta` weekdays, skipping Sat/Sun.
 * delta > 0 moves forward; delta < 0 moves backward.
 */
export function addWeekdays(date, delta) {
  const d = new Date(date);
  const step = delta > 0 ? 1 : -1;
  let remaining = Math.abs(delta);
  while (remaining > 0) {
    d.setDate(d.getDate() + step);
    if (d.getDay() !== 0 && d.getDay() !== 6) remaining--;
  }
  return d;
}
